<template>
  <div>
    <h1 style="margin-top: 60px; margin-bottom: 30px">Privacy Policy</h1>
    <div class="corner">
      <div class="content">
        <br/>
        <strong>App:</strong> Charging Complete Alert
        <br/>
        <strong>Effective date:</strong> August 12, 2025
        <br/>
        <br/>

        <strong>Information We Collect</strong>
        <br/>
        Hashed Device ID only. We generate a one-way hashed identifier (“Hashed ID”) by combining the Android ID with an app-specific key (salt) and applying a one-way hash.
        <br/>
        We do not collect or store the raw Android ID, names, emails, precise location, contacts, photos, or any other personal data.
        <br/>
        <br/>

        <strong>How We Use the Hashed ID</strong>
        <br/>
        App functionality: Prevent duplicate device/installation abuse and operate core features.
        <br/>
        Security & fraud prevention: Detect misuse, spam, or unauthorized activity.
        <br/>
        We do not sell data and do not use the Hashed ID for advertising or cross-app tracking.
        <br/>
        <br/>

        <strong>Sharing</strong>
        <br/>
        We do not share personal data with third parties, except trusted service providers (e.g., cloud hosting) that process it on our behalf under confidentiality and security obligations.
        <br/>
        <br/>

        <strong>Retention & Deletion</strong>
        <br/>
        We keep the Hashed ID only as long as necessary for the purposes above and then delete it.
        <br/>
        <br/>

        <strong>Security</strong>
        <br/>
        We use encryption in transit and at rest, access controls, and one-way hashing with a private key/salt to protect data.
        <br/>
        <br/>

        <strong>International Transfers</strong>
        <br/>
        Data may be processed on servers outside your country. We protect it as described in this policy.
        <br/>
        <br/>

        <strong>Changes</strong>
        <br/>
        We may update this policy and will post the new version with a new effective date.
        <br/>
        <br/>

        <strong>Contact</strong>
        <br/>
        evidence.erae@gmail.com
        <br/>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.corner {
  margin: 30px;
  border-radius: 10px;
  border: 2px solid #ffffff;
  background-color: #ffffff;
  padding: 10px;
  text-align: left;
}

.content {
  padding: 0 0 0 10px;
  margin: 0 0;
  text-align: left;
}

h1 {
  text-align: center;
}

h2 {
  text-align: left;
  font-size: 13px;
  color: #aaaaaa;
  padding-bottom: 15px;
}

h3 {
  text-align: center;
  margin: 3px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
